import type { FC } from "react";
import { Button } from "react-bootstrap";

import { Lightbox } from "components/Lightbox";

import { useAppSelector } from "store/hooks";
import { selectInvalidToken } from "store/slices/invalidToken";
import { selectSessionConflict } from "store/slices/sessionConflict";

import IconDestructbara from "images/icons/destructbara.svg";

interface Props {
  show: boolean;
  onHide: () => void;
  onRetry: () => void;
  onCancel: () => void;
}

// Nadpis je pod ilustrací kapybary, takže zůstává v těle a jen pojmenuje dialog. [TD-344]
const ErrorModal: FC<Props> = ({ show, onHide, onRetry, onCancel }) => {
  // Při konfliktu tréninku by opakování jen vrátilo tutéž chybu — místo toho je vidět
  // SessionConflictModal (v App.tsx, přes všechny stránky studenta). Tady, ne u volajících:
  // chybu odpovědi zpracovává 11 komponent. [TD-461]
  const sessionConflict = useAppSelector(selectSessionConflict);
  // Stejně tak při neplatném tokenu (student je přihlášený jinde): opakování by vrátilo tutéž
  // chybu a nad ním by ležel InvalidTokenModal. [TD-460]
  const invalidToken = useAppSelector(selectInvalidToken);

  return (
    <Lightbox
      show={show && sessionConflict === null && invalidToken === "idle"}
      onHide={onHide}
      className="mt-5"
      bodyTitleId="error-modal-title"
    >
      <div className="d-flex justify-content-center">
        <IconDestructbara style={{ width: "140px" }} />
      </div>
      <div className="text-center mb-5">
        {/* Velikost drží `.fs-18`, ať se sjednocením na `h2` (globálně 17 px) nezmění
          vzhled — původní odstavec s `.h3` měl 18 px ($h3-font-size). [TD-344] */}
        <h2 id="error-modal-title" className="fs-18">
          Neočekávaná chyba
        </h2>
        <p>
          Vypadá to, že nám kapybara překousala kabel a došlo k neočekávané chybě, kvůli které jsme nemohli opravit
          odpověď na otázku.
        </p>
        <p className="fw-bold">Zkuste na úlohu prosím odpovědět znovu.</p>
      </div>
      <Button className="w-100 mb-3" onClick={onRetry}>
        Zkusit odpovědět znovu
      </Button>
      <Button className="w-100" variant="outline-secondary" onClick={onCancel}>
        Přeskočit otázku
      </Button>
    </Lightbox>
  );
};

export default ErrorModal;
